import React from 'react';
import { useAppStore } from '../store/app-store';
import { nanoid } from 'nanoid';

export function Sidebar() {
  const {
    conversations,
    activeConversationId,
    addConversation,
    setActiveConversation,
    deleteConversation,
    statistics
  } = useAppStore();

  const handleNewConversation = () => {
    const newConv = {
      id: nanoid(),
      title: 'New Conversation',
      messages: [],
      createdAt: Date.now(),
      updatedAt: Date.now()
    };

    addConversation(newConv);
  };

  const handleDeleteConversation = (id, e) => {
    e.stopPropagation();
    if (confirm('Delete this conversation?')) {
      deleteConversation(id);
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;

    if (diff < 86400000) { // Less than 24 hours
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } else if (diff < 604800000) { // Less than 7 days
      return date.toLocaleDateString([], { weekday: 'short' });
    } else {
      return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h1>Cloudflare Dev Agent</h1>
        <button className="new-chat-btn" onClick={handleNewConversation}>
          + New Chat
        </button>
      </div>

      <div className="conversations-list">
        {conversations.length === 0 ? (
          <div className="empty-state">
            <p>No conversations yet</p>
            <p className="hint">Click "New Chat" to start</p>
          </div>
        ) : (
          conversations.map(conv => (
            <div
              key={conv.id}
              className={`conversation-item ${
                conv.id === activeConversationId ? 'active' : ''
              }`}
              onClick={() => setActiveConversation(conv.id)}
            >
              <div className="conversation-info">
                <div className="conversation-title">
                  {conv.title}
                </div>
                <div className="conversation-meta">
                  <span className="message-count">
                    {conv.messages.length} messages
                  </span>
                  <span className="timestamp">
                    {formatTimestamp(conv.updatedAt)}
                  </span>
                </div>
              </div>
              <button
                className="delete-btn"
                onClick={(e) => handleDeleteConversation(conv.id, e)}
                title="Delete conversation"
              >
                ×
              </button>
            </div>
          ))
        )}
      </div>

      <div className="sidebar-footer">
        <div className="stats">
          <div className="stat-item">
            <span className="stat-label">Messages:</span>
            <span className="stat-value">{statistics.totalMessages}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Agents:</span>
            <span className="stat-value">{statistics.totalAgents}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Compactions:</span>
            <span className="stat-value">{statistics.totalCompactions}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Tokens Saved:</span>
            <span className="stat-value">{statistics.tokensSaved.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
